import { useEffect } from 'react';
import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import PostHeaderInfo from 'src/modules/community/singlePost/components/postHeaderInfo';
import { titleLarge, titleMedium } from 'styles-js/mixins/typography';

export default function PostHeader() {
  const title = useSelector(({ pages }) => pages.singlePost.post?.title);

  useEffect(() => {
    const hash = location.hash?.replace('#', '');
    const position = document.getElementById('post-heading')?.offsetTop;
    if (hash === 'post_title' && !!position) {
      window.scrollTo({
        behavior: 'smooth',
        top: position - 52,
      });
    }
  }, []);

  return (
    <Header className="post-header">
      <H1 data-testid="post-heading" id="post-heading">
        {title}
      </H1>
      <PostHeaderInfo />
    </Header>
  );
}

const Header = styled.header`
  margin-bottom: 30px;
`;

const H1 = styled.h1`
  ${titleMedium}
  margin-top: 0;
  margin-bottom: 10px;
  overflow-wrap: break-word; // Partial support for IE11
  word-wrap: break-word; // IE11

  @media (${({ theme }) => theme.overScreenSmall}) {
    ${titleLarge};
  }
`;
